export default __webpack_public_path__ + "static/media/profile-background-mobile.69593853.jpg";